export const translations = {
  it: {
    // Map page
    'map.hillshadeLayer': 'Rilievo',
    'map.streetsLayer': 'Strade e località',
    'map.loading': 'Caricamento località...',
    'map.loadError': 'Impossibile caricare le località',
    'map.networkError': 'Errore di rete. Riprova.',
    'map.tokenError': 'Errore di autenticazione per il server delle mappe.',
    'map.retry': 'Riprova',
    'map.favourites': 'Preferiti',
    'map.search': 'Cerca',
    'map.menu': 'Menu',
    'map.logout': 'Disconnetti',
    'map.locationDenied': 'Accesso alla posizione negato. Abilita i permessi di geolocalizzazione nelle impostazioni del browser.',
    'map.locationUnavailable': 'Posizione non disponibile. Verifica la connessione GPS.',
    'map.locationTimeout': 'Richiesta di posizione scaduta. Riprova.',
    'map.locationError': 'Errore sconosciuto durante la richiesta della posizione.',

    // Auth page
    'auth.title': 'RASP Map',
    'auth.description': 'Inserisci la tua chiave di autenticazione per accedere alle previsioni parapendio',
    'auth.howToGetKey': 'Come ottenere la chiave di accesso',
    'auth.instructions.step1': 'Accedi al sito',
    'auth.instructions.step2': 'Nel menu vai a "Meteo → Consulta il servizio meteo"',
    'auth.instructions.step3': 'Seleziona l\'icona del telefono e nel popup che si apre scegli "Richiedi istruzioni e chiavi di attivazione"',
    'auth.instructions.step4': 'Copia il codice in grassetto e incollalo nel campo qui sotto',
    'auth.keyLabel': 'Chiave di autenticazione:',
    'auth.keyPlaceholder': 'XXXX-XXXX-XXXX-XXXX',
    'auth.submit': 'Accedi',
    'auth.submitting': 'Autenticazione...',
    'auth.errorEmpty': 'Inserisci la tua chiave di autenticazione',
    'auth.errorFailed': 'Autenticazione fallita',
    'auth.errorNetwork': 'Errore di rete. Riprova.',

    // Search overlay
    'search.title': 'Cerca Località',
    'search.placeholder': 'Cerca località...',
    'search.emptyState': 'Inserisci il nome di una località per cercare tra {count} località',
    'search.resultsFound': '{count} risultat{plural} trovat{plural}',
    'search.noResults': 'Nessuna località trovata per "{query}"',
    'search.viewForecast': 'Mostra previsioni',

    // Favourites overlay
    'favourites.title': 'Preferiti',
    'favourites.count': '{count} preferit{plural}',
    'favourites.empty': 'Nessun preferito salvato',
    'favourites.add': 'Aggiungi ai preferiti',
    'favourites.remove': 'Rimuovi dai preferiti',

    // Spot overlay
    'spot.error': 'Errore',
    'spot.notFound': 'Spot non trovato',
    'spot.loading': 'Caricamento previsioni...',
    'spot.loadError': 'Impossibile caricare l\'immagine delle previsioni',
    'spot.coordinates': 'Coordinate: {lat}, {lng}',
    'spot.retry': 'Riprova',

    // Days of week
    'day.mon': 'Lun',
    'day.tue': 'Mar',
    'day.wed': 'Mer',
    'day.thu': 'Gio',
    'day.fri': 'Ven',
    'day.sat': 'Sab',
    'day.sun': 'Dom',
    'day.today': 'Oggi',

    // User account
    'account.title': 'Account',
    'account.username': 'Username:',
    'account.accountId': 'ID conto:',
    'account.creditRemaining': 'Credito res.:',
    'account.expiryDate': 'Scade il:',
    'account.loading': 'Caricamento informazioni account...',
    'account.error': 'Impossibile caricare le informazioni dell\'account',
    'account.retry': 'Riprova',

    // About
    'about.title': 'Informazioni',
    'about.versionInfo': 'Versione applicazione',
    'about.version': '3.0',
    'about.forecastSystem': 'Sistema di previsione',
    'about.forecastCredit': 'Creato e mantenuto da Andrea Barcellona',
    'about.mapViewer': 'Visualizzatore RASP Map',
    'about.mapCredit': 'Con il contributo di Rory Stephenson',

    // Logout confirmation
    'logout.title': 'Conferma disconnessione dall\'account',
    'logout.message': 'Se ti disconnetti dal tuo account dovrai ripetere l\'attivazione con una nuova chiave. Sei sicuro di volerti disconnettere?',
    'logout.cancel': 'Annulla',
    'logout.confirm': 'Disconnetti',

    // UI elements
    'ui.close': 'Chiudi',
    'ui.back': 'Indietro',
    'ui.location': 'Posizione',
    'ui.windsock': 'Manica a vento',
    'ui.externalLink': 'Link esterno',
    'ui.windgramFor': 'Windgram per {name}',
    'wg.tabWindgram': 'Windgram',
    'wg.tabSounding': 'Curva di stato',
    'wg.point': 'Punto {lat}, {lon}',
    'wg.loading': 'Calcolo del windgram...',
    'wg.notAvailable': 'Windgram non disponibile in questo punto per questo giorno.',
    'wg.notAvailableHint': 'I windgram al volo coprono le zone dei ritagli a 2 km. Prova un altro giorno o un punto vicino sulla terraferma.',
    'wg.noCredit': 'Credito esaurito: sono consultabili solo i giorni già gratuiti.',
    'wg.loadError': 'Impossibile caricare il windgram',
    'wg.instabile': 'Instabile <--',
    'wg.stabile': '--> Stabile',
    'wg.gradiente': 'Gradiente termico (ΔT/100 m)',
    'wg.griglia': 'Griglia',
    'wg.terreno': 'quota del terreno nel modello',
    'wg.cima': 'Cima strato rimescolato',
    'wg.base': 'Base cumuli e copertura',
    'wg.torre': 'Sviluppo dei cumuli',
    'wg.zero': 'Zero termico',
    'wg.vela': 'Quota max in termica',
    'wg.nubi': 'Nubi (più fitto = più coperto)',
    'wg.saturo': 'Aria satura',
    'wg.barbe': 'Segnavento in nodi: mezza tacca 5, tacca 10, bandierina 50. L\'asta punta da dove viene il vento.',
    'wg.nota': 'Windgram completo, disegnato dai profili verticali del modello in questa cella. In alto: ascendenze medie in m/s.',
    'wg.run': 'run',
    'wg.elaborato': 'elaborato il',
    'wg.tapHour': 'Tocca un\'ora del grafico per i numeri.',
    'wg.detTop': 'Cima strato',
    'wg.detBase': 'Base cumuli',
    'wg.detNoCu': 'niente cumuli',
    'wg.detOver': 'sovrasviluppi',
    'wg.detClouds': 'Nubi',
    'wg.detRain': 'Pioggia',
    'wg.detNoRain': 'niente pioggia',
    'wg.detThermal': 'Termica',
    'wg.detMaxAlt': 'Quota max',
    'wg.sondTemperatura': 'Temperatura (°C)',
    'wg.sondLegenda': 'Rosso temperatura · blu punto di rugiada · nero tratteggiato particella media dei primi 50 hPa · grigio a sinistra nubi',
    'ui.openWindy': 'Apri Airgram in Windy',
    'ui.openMeteoParapente': 'Apri Meteo-Parapente',
    'ui.tutorialPhoneIcon': 'Icona telefono',
    'ui.tutorialPopup': 'Popup richiesta chiave',
    'ui.tutorialKey': 'Codice di accesso',

    // Common
    'common.loading': 'Caricamento...',
    'common.error': 'Errore',
    'common.retry': 'Riprova',

    // App Update
    'update.title': 'Nuova versione disponibile',
    'update.message': 'Una nuova versione dell\'app è disponibile. Ricarica per aggiornare.',
    'update.reload': 'Ricarica',

    // Announcements
    'announcement.ok': 'OK',
    'sess.titleComputer': 'RASP è in uso su un altro computer',
    'sess.titlePhone': 'RASP è in uso su un altro smartphone',
    'sess.body': "L'account è aperto su un altro dispositivo dello stesso tipo ({who}). Si può usare da un computer e da uno smartphone alla volta.",
    'sess.useHere': 'Usa qui',
    'sess.wait': 'Attendere…',
    'sess.viewer': 'viewer FIVL',
    'sess.site': 'sito RASP',
    'sess.app': 'app RASP',
    'news.title': 'Aggiornamento alla versione 3.5.0',
    'news.message': 'Novità:\n\n• Tenendo premuto il dito in un punto della mappa viene mostrato il windgram e la curva di stato per quel punto.\n\n• Toccando un orario del windgram vengono mostrati sotto i dati riepilogativi di quell\'ora.',
  },
  en: {
    // Map page
    'map.hillshadeLayer': 'Rilief',
    'map.streetsLayer': 'Streets',
    'map.loading': 'Loading locations...',
    'map.loadError': 'Unable to load locations',
    'map.networkError': 'Network error. Please retry.',
    'map.tokenError': 'Authentication error for map server.',
    'map.retry': 'Retry',
    'map.favourites': 'Favourites',
    'map.search': 'Search',
    'map.menu': 'Menu',
    'map.logout': 'Logout',
    'map.locationDenied': 'Location access denied. Please enable location permissions in your browser settings.',
    'map.locationUnavailable': 'Location unavailable. Check your GPS connection.',
    'map.locationTimeout': 'Location request timed out. Please try again.',
    'map.locationError': 'Unknown error while requesting location.',

    // Auth page
    'auth.title': 'RASP Map',
    'auth.description': 'Enter your authentication key to access paragliding forecasts',
    'auth.howToGetKey': 'How to get your access key',
    'auth.instructions.step1': 'Log in to',
    'auth.instructions.step2': 'In the menu go to "Meteo → Consulta il servizio meteo"',
    'auth.instructions.step3': 'Select the phone icon and in the popup choose "Richiedi istruzioni e chiavi di attivazione"',
    'auth.instructions.step4': 'Copy the bold code and paste it in the field below',
    'auth.keyLabel': 'Authentication key:',
    'auth.keyPlaceholder': 'XXXX-XXXX-XXXX-XXXX',
    'auth.submit': 'Login',
    'auth.submitting': 'Authenticating...',
    'auth.errorEmpty': 'Please enter your authentication key',
    'auth.errorFailed': 'Authentication failed',
    'auth.errorNetwork': 'Network error. Please retry.',

    // Search overlay
    'search.title': 'Search Locations',
    'search.placeholder': 'Search locations...',
    'search.emptyState': 'Enter a location name to search {count} forecast locations',
    'search.resultsFound': '{count} result{plural} found',
    'search.noResults': 'No locations found for "{query}"',
    'search.viewForecast': 'View forecast',

    // Favourites overlay
    'favourites.title': 'Favourites',
    'favourites.count': '{count} favourite{plural}',
    'favourites.empty': 'No favourites saved',
    'favourites.add': 'Add to favourites',
    'favourites.remove': 'Remove from favourites',

    // Spot overlay
    'spot.error': 'Error',
    'spot.notFound': 'Spot not found',
    'spot.loading': 'Loading forecast...',
    'spot.loadError': 'Failed to load forecast image',
    'spot.coordinates': 'Coordinates: {lat}, {lng}',
    'spot.retry': 'Retry',

    // Days of week
    'day.mon': 'Mon',
    'day.tue': 'Tue',
    'day.wed': 'Wed',
    'day.thu': 'Thu',
    'day.fri': 'Fri',
    'day.sat': 'Sat',
    'day.sun': 'Sun',
    'day.today': 'Today',

    // User account
    'account.title': 'Account',
    'account.username': 'Username:',
    'account.accountId': 'Account ID:',
    'account.creditRemaining': 'Credit remaining:',
    'account.expiryDate': 'Expires:',
    'account.loading': 'Loading account information...',
    'account.error': 'Unable to load account information',
    'account.retry': 'Retry',

    // About
    'about.title': 'About',
    'about.versionInfo': 'Application Version',
    'about.version': '3.0',
    'about.forecastSystem': 'Forecast system',
    'about.forecastCredit': 'Created and maintained by Andrea Barcellona',
    'about.mapViewer': 'RASP Map Viewer',
    'about.mapCredit': 'With contributions from Rory Stephenson',

    // Logout confirmation
    'logout.title': 'Confirm Logout from your account',
    'logout.message': 'If you log out of your account, you\'ll need to re-activate with a new key. Are you sure you want to log out?',
    'logout.cancel': 'Cancel',
    'logout.confirm': 'Logout and disconnect',

    // UI elements
    'ui.close': 'Close',
    'ui.back': 'Back',
    'ui.location': 'Location',
    'ui.windsock': 'Windsock',
    'ui.externalLink': 'External link',
    'ui.windgramFor': 'Windgram for {name}',
    'wg.tabWindgram': 'Windgram',
    'wg.tabSounding': 'Sounding',
    'wg.point': 'Point {lat}, {lon}',
    'wg.loading': 'Computing windgram...',
    'wg.notAvailable': 'Windgram not available at this point for this day.',
    'wg.notAvailableHint': 'On-the-fly windgrams cover the 2 km crop areas. Try another day or a nearby point on land.',
    'wg.noCredit': 'Out of credit: only the free days can be viewed.',
    'wg.loadError': 'Unable to load the windgram',
    'wg.instabile': 'Unstable <--',
    'wg.stabile': '--> Stable',
    'wg.gradiente': 'Lapse rate (ΔT/100 m)',
    'wg.griglia': 'Grid',
    'wg.terreno': 'model terrain height',
    'wg.cima': 'Top of mixed layer',
    'wg.base': 'Cumulus base and cover',
    'wg.torre': 'Cumulus development',
    'wg.zero': 'Freezing level',
    'wg.vela': 'Max thermalling height',
    'wg.nubi': 'Cloud (denser = more cover)',
    'wg.saturo': 'Saturated air',
    'wg.barbe': 'Wind barbs in knots: half barb 5, full barb 10, pennant 50. The staff points to where the wind comes from.',
    'wg.nota': 'Full windgram, drawn from the model vertical profiles in this cell. Top: average thermal strength in m/s.',
    'wg.run': 'run',
    'wg.elaborato': 'computed on',
    'wg.tapHour': 'Tap an hour on the chart for the numbers.',
    'wg.detTop': 'Top of layer',
    'wg.detBase': 'Cloudbase',
    'wg.detNoCu': 'no cumulus',
    'wg.detOver': 'overdevelopment',
    'wg.detClouds': 'Clouds',
    'wg.detRain': 'Rain',
    'wg.detNoRain': 'no rain',
    'wg.detThermal': 'Thermal',
    'wg.detMaxAlt': 'Max height',
    'wg.sondTemperatura': 'Temperature (°C)',
    'wg.sondLegenda': 'Red temperature · blue dew point · black dashed mixed-layer parcel (lowest 50 hPa) · grey on the left clouds',
    'ui.openWindy': 'Open Airgram in Windy',
    'ui.openMeteoParapente': 'Open Meteo-Parapente',
    'ui.tutorialPhoneIcon': 'Phone icon',
    'ui.tutorialPopup': 'Key request popup',
    'ui.tutorialKey': 'Access code',

    // Common
    'common.loading': 'Loading...',
    'common.error': 'Error',
    'common.retry': 'Retry',

    // App Update
    'update.title': 'New version available',
    'update.message': 'A new version of the app is available. Please reload to update.',
    'update.reload': 'Reload',

    // Announcements
    'announcement.ok': 'OK',
    'sess.titleComputer': 'RASP is in use on another computer',
    'sess.titlePhone': 'RASP is in use on another smartphone',
    'sess.body': 'The account is open on another device of the same kind ({who}). It can be used from one computer and one smartphone at a time.',
    'sess.useHere': 'Use here',
    'sess.wait': 'Please wait…',
    'sess.viewer': 'FIVL viewer',
    'sess.site': 'RASP website',
    'sess.app': 'RASP app',
    'news.title': 'Updated to version 3.5.0',
    'news.message': 'What\'s new:\n\n• Press and hold a point on the map to see the windgram and the sounding for that point.\n\n• Tap a time on the windgram to see a summary of that hour below it.',
  }
} as const;

export type TranslationKey = keyof typeof translations.it;
export type Language = keyof typeof translations;
